export default __webpack_public_path__ + "locales/ru/InviteDialog.json?hash=b4f1dbf1ae0d1209fd5709fd58135d84";